import axios from 'axios'

export async function Post(entity, endpoint, data) {
    let result = false;
    await axios.post(`api/${entity}/${endpoint}`, data, {
        headers: {
            // Overwrite Axios's automatically set Content-Type
            'Content-Type': 'application/json' 
        }
    })
        .then(response => {
            console.log(response)
            result = response.data
        })
        .catch(error => {
            console.log(error);
        })
    return result
}

export async function Get(entity, endpoint, data) {
    let result = null;

    await axios.get(`api/${entity}/${endpoint}`, {
        headers: {
            // Overwrite Axios's automatically set Content-Type
            'Content-Type': 'application/json'
        },
        params: data
    })
        .then(response => {
                console.log(response)
                result = response.data;
        })
        .catch(error => {
            console.log(error)
            result = false;
        });


    return result


}

export async function Put(entity, endpoint, data) {
    let result = false;
    await axios.put(`api/${entity}/${endpoint}`, data, {
        headers: {
            // Overwrite Axios's automatically set Content-Type
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
                result = response.data
        })
        .catch(error => {
            console.log(error);
        })
    return result
}

export async function Delete(entity, endpoint, data) {
    let result = false;
    await axios.delete(`api/${entity}/${endpoint}`, {
        headers: {
            // Overwrite Axios's automatically set Content-Type
            'Content-Type': 'application/json'
        },
        params: data
    })
        .then(response => {
                result = response.data
        })
        .catch(error => {
            console.log(error);
        })
    return result
}

export default { Post, Get, Put, Delete }